import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
}

export const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    loadingStart: (state, action) => {
      state.loading = true
    },
    loadingEnd: (state, action) => {
      state.loading = false
    },
  }
});

export const { loadingStart, loadingEnd } = loaderSlice.actions;
export default loaderSlice.reducer;